import clsx from 'clsx';
import type { Message } from '@flock-types/chat.types';
import { LEGACY_REACTION_MAP } from '@/config/emoji-config';
import { auth } from '@/config/firebase';

/** Map legacy string keys ('prayer_hands') to emoji for old messages. */
function displayEmoji(key: string): string {
  return LEGACY_REACTION_MAP[key] ?? key;
}

interface Props {
  message: Message;
  own: boolean;
  onToggle?: (emoji: string, reacted: boolean) => void;
}

export default function ReactionDisplay({ message, own, onToggle }: Props) {
  const uid = auth.currentUser?.uid;
  const entries = Object.entries(message.reactions || {}).filter(
    ([, uids]) => (uids?.length ?? 0) > 0
  );
  if (entries.length === 0) return null;

  return (
    <div className={clsx('mt-1 flex flex-wrap gap-1', own && 'justify-end')}>
      {entries.map(([key, uids]) => {
        const reacted = Boolean(uid && uids.includes(uid));
        return (
          <button
            key={key}
            onClick={() => onToggle?.(key, reacted)}
            className={clsx(
              'flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs transition',
              reacted
                ? 'border-flock-navy-400 bg-flock-navy-100 text-flock-navy-800'
                : 'border-flock-gray-200 bg-white text-flock-navy-600 hover:bg-flock-navy-50'
            )}
            title={reacted ? 'Remove reaction' : 'React'}
          >
            <span>{displayEmoji(key)}</span>
            <span className="font-medium">{uids.length}</span>
          </button>
        );
      })}
    </div>
  );
}
